<div class="modal__header modal__header--warning">
		<h2 class="title" id="modal__title">It was not possible create your account</h2>
		<div class="modal__header-actions">
			<button aria-label="Close dialog" (click)="closeModal()">
				<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
			</button>
		</div>
	</div>
	<div class="modal__body sl--scrollable">
		Due to technical issues, at the moment, we can´t create your account.<br>
		Please, try again in 10 minutes or continue without discount.
	</div>
	<div class="modal__body sl--scrollable">
		Start a new search and try registering again in 10 minutes.<br>
		<a class="link" (click)="TAP_newSearch()" href="javascript:;" role="button">New Search</a>
	</div>
	<div class="modal__footer">
		<div class="modal__footer-action"><button class="button" (click)="TAP_goWithoutDiscount()">Continue without discount</button></div>
	</div>
